import { Component, input } from '@angular/core';
import { TransportListIconName } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { TimelineStatus } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/interfaces';

@Component({
  selector: 'app-transport-list-card-overflow-line-list',
  standalone: true,
  imports: [],
  templateUrl: './transport-list-card-overflow-line-list.component.html',
  styleUrls: ['./transport-list-card-overflow-line-list.component.scss'],
})
export class TransportListCardOverflowLineListComponent  {
  public lineHeight = input.required<number>();
  public iconName = input.required<TransportListIconName>();
  public status = input.required<TimelineStatus>();
  public isFirst = input.required<boolean>();
  public isLast = input.required<boolean>();
}
